// Utils
import { cn } from '../../utils/cn';

// Types
type SkeletonProps = {
  /** Additional className for custom styling */
  className?: string;
  /** Whether to apply the pulse animation */
  animate?: boolean;
};

/**
 * Base Skeleton component - a simple animated placeholder
 * Use this as a building block for more complex skeleton layouts
 */
export const Skeleton = ({ className, animate = true }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'bg-gray-200 rounded-8',
        animate && 'animate-pulse',
        className
      )}
      aria-hidden="true"
    />
  );
};

